import { ActionTypes } from 'store/constants';

// ** widget wheel:-
export const listUser = (returnedPayload) => ({ type: ActionTypes.widgets.listUsers, payload: returnedPayload });
export const updateWheelUser = (returnPayload) => ({type: ActionTypes.widgetWheel.updateUser, payload: returnPayload});
export const updateWheelSelectedUser = (returnPayload) => ({type: ActionTypes.widgetWheel.updateSelectedUser, payload: returnPayload});
export const updateVocabCognates = (returnedPayload) => ({ type: ActionTypes.widgetWheel.updateVocabCognates, payload: returnedPayload });


// ** widget group:-
export const updateGroup = (returnPayload) => ({type: ActionTypes.widgetGroup.update, payload: returnPayload})

// ** widget station:-
export const updateStation = (returnPayload) => ({type: ActionTypes.widgetStation.update, payload: returnPayload})
